import store from '@polleverywhere/redux'
import { slice as appSlice } from '../slices/app'

export default function gateByFeature (name, features = {}, state) {
  if (!features[name]) {
    store.dispatch(appSlice.pageUpdated('not_found'))
    return true
  }
}
